import Axios from 'axios';

export default {
  namespaced: true,
  state: {
    account: { errors: {}, form: {}},
    personal: { errors: {}, form: {}},
    afronden: { errors: {}, form: {}},
    aanbod: {},
    vraag: {},
    prikbord: {},
    config: {},
    steps: [],
    activeIdx: 0,
    loading: false
  },
  mutations: {
    startLoading (state) {
      state.loading = true;
    },
    endLoading (state) {
      state.loading = false;
    },
    setConfig (state, payload) {
      state.config = payload;
    },
    setSteps (state, payload) {
      state.steps = payload.steps;
    },
    prev (state) {
      state.activeIdx--;
    },
    next (state) {
      state.activeIdx++;
    },
    goTo (state, idx) {
      state.activeIdx = idx;
    },
    set (state, payload) {
      state[payload.name] = payload.value;
    },
    setErrors (state, payload) {
      if (typeof state[payload.step][payload.name] !== 'undefined') {
        state[payload.step][payload.name].errors = payload.errors;
      } else {
        state[payload.step].errors = payload.errors;
      }
    },
    setFormData (state, payload) {
      if (typeof state[payload.step][payload.name] !== 'undefined') {
        state[payload.step][payload.name].form = payload.formData;
      } else {
        state[payload.step].form = payload.formData;
      }
    }
  },
  getters: {
    active: state => {
      if (typeof state.steps[state.activeIdx] !== 'undefined') {
        return state.steps[state.activeIdx].id;
      }
    },
    errorLayout: state => (step, name, field) => {
      if (typeof state[step][name] !== 'undefined') {
        return state[step][name].errors.hasOwnProperty(field) ? 'is-danger' : '';
      }
      return state[step].errors.hasOwnProperty(field) ? 'is-danger' : '';
    },
    hasError: state => (step, name, field) => {
      if (typeof state[step][name] !== 'undefined') {
        return state[step][name].errors.hasOwnProperty(field);
      }
      return state[step].errors.hasOwnProperty(field);
    },
    getError: state => (step, name, field) => {
      if (typeof state[step][name] !== 'undefined') {
        return state[step][name].errors.hasOwnProperty(field) ? state[step][name].errors[field][0] : '';
      }
      return state[step].errors.hasOwnProperty(field) ? state[step].errors[field][0] : '';
    },
    counter: state => {
      return `${state.activeIdx + 1}<span class="has-text-size-20 has-text-grey">/${state.steps.length}</span>&nbsp;&nbsp;`;
    },
    moduleCount: state => {
      return ['aanbod', 'vraag', 'prikbord'].reduce((total, moduleType) => total + Object.keys(state[moduleType]).length, 0);
    }
  },
  actions: {
    goTo ({ state, commit }, step) {
      var idx = 4;
      for (var i in state.steps) {
        if (state.steps[i].id === step) {
          idx = parseInt(i);
        }
      }
      commit('goTo', idx);
    },
    async register ({ state }) {
      const form = {
        account: state.account,
        personal: state.personal,
        aanbod: state.aanbod,
        vraag: state.vraag,
        prikbord: state.prikbord,
        correspondentie: {
          mailingAlgemeen: state.afronden.form.mailingAlgemeen,
          mailingNieuwsbrief: state.afronden.form.mailingNieuwsbrief,
          mailingReclame: state.afronden.form.mailingReclame
        },
        motivatie: {
          redenAanmelding: state.afronden.form.redenAanmelding,
          bekendVia: state.afronden.form.bekendVia
        }
      };
      await Axios.post('/api/v1/register', form).then(response => {
        window.location.href = response.data.url;
      });
    },
    validateData ({ commit, getters }, payload) {
      const step = payload.step || getters.active;
      return new Promise((resolve, reject) => {
        Axios.post(`/api/v1/register/validate/${payload.name}`, payload.formData).then(response => {
          commit('setErrors', { step, name: payload.module, errors: {}});
          resolve('OK');
        }).catch(error => {
          commit('setErrors', { step, name: payload.module, errors: error.response.data.errors });
          reject('Error');
        });
      });
    },
    validateUniqueUsername ({ dispatch, getters, state }) {
      if (state[getters.active].form.emailadres) {
        dispatch('validateData', { name: 'uniqueUsername', formData: state[getters.active].form });
      }
    },
    async next ({ commit, dispatch, getters, state }) {
      commit('startLoading');
      var requests = [];
      if (getters.active === 'afronden') {
        requests.push(dispatch('validateData', { name: getters.active, formData: state[getters.active].form }));
      // await dispatch('register');
      // return;
      }
      if (getters.active === 'personal' || getters.active === 'account') {
        requests.push(dispatch('validateData', { name: getters.active, formData: state[getters.active].form }));
      }
      if (getters.active === 'modules') {
        ['aanbod', 'vraag', 'prikbord'].forEach((step) => {
          for (var name in state[step]) {
            const feature = state[step][name];
            if (feature.hasOwnProperty('scope')) {
              requests.push(dispatch('validateData', {
                step,
                name: 'marktplaats',
                module: name,
                formData: Object.assign({ scope: feature.scope }, feature.form, state.personal.form)
              }));
              continue;
            }
            requests.push(dispatch('validateData', {
              step,
              name: 'vacaturebank',
              module: name,
              formData: Object.assign(feature.form, state.personal.form)
            }));
          }
        });
      }
      await Promise.all(requests).then(() => {
        if (getters.active === 'afronden') {
          dispatch('register');
        } else {
          commit('endLoading');
          commit('next');
        }
      }).catch((error) => {
        commit('endLoading');
        return error;
      });
    }
  }
};
